<div class="askPanel">
  <!-- Dark forest-green header (Figma "AI module"): sparkle badge, title and subtitle, close button,
       then the tabs as pills. "Related articles" and "Ask AI" show only for companies in the Ask AI
       rollout; "Technical support" shows for every company in an app that wires Zoho's widget. With a
       single tab there is nothing to switch to, so the title alone names the panel. -->
  <header class="askPanel-header">
    <div class="askPanel-header-row">
      <span class="askPanel-header-badge">
        <img src="images/ask-panel/sparkle.svg" width="18" height="18" alt="" />
      </span>
      <div class="askPanel-header-text">
        <h2 class="askPanel-header-title">{{ "AskPanelTitle" | translate }}</h2>
        <p class="askPanel-header-subtitle">{{ "AskPanelSubtitle" | translate }}</p>
      </div>
      <button
        type="button"
        class="askPanel-header-close"
        (click)="closePanel.emit()"
        matTooltip="{{ 'Close' | translate }}"
        [attr.aria-label]="'Close' | translate"
      >
        <img src="images/ask-panel/close.svg" width="24" height="24" alt="" />
      </button>
    </div>
    @if (tabs().length > 1) {
      <div class="askPanel-tabs" role="tablist">
        @for (tab of tabs(); track tab) {
          <button
            type="button"
            role="tab"
            class="askPanel-tab"
            [class.askPanel-tab--active]="activeTab() === tab"
            [attr.aria-selected]="activeTab() === tab"
            (click)="selectTab(tab)"
          >
            @switch (tab) {
              @case ("articles") {
                {{ "AskArticlesTab" | translate }}
              }
              @case ("chat") {
                {{ "AskChatTab" | translate }}
              }
              @case ("support") {
                {{ "SupportTab" | translate }}
              }
            }
          </button>
        }
      </div>
    }
  </header>

  <!--
    Both tab bodies stay mounted at all times (toggled with [hidden], not @if/@else): AskPanelChatComponent
    holds its conversation in its own signals, and an @if/@else here would destroy/recreate it — and
    wipe the conversation — on every tab switch. Only chatAvailable gates whether the chat body exists
    at all (an app that never wires KbChatService has no reason to build it).
  -->
  @if (articlesAvailable()) {
  <ng-scrollbar class="askPanel-body" [hidden]="activeTab() !== 'articles'">
    <div class="askPanel-body-inner">
      @if (isLoading()) {
        @for (placeholder of [1, 2, 3, 4]; track placeholder) {
          <ngx-skeleton-loader
            [theme]="{
              height: '86px',
              borderRadius: '12px',
              marginBottom: '12px',
            }"
          />
        }
      } @else if (hasError()) {
        <p class="mat-body-1 f-s-14 askPanel-message">
          {{ "AskLoadFailed" | translate }}
          <a href="javascript:void(0)" (click)="retry()">{{ "Retry" | translate }}</a>
        </p>
      } @else if (articles().length === 0) {
        <p class="mat-body-1 f-s-14 askPanel-message">{{ "AskNoArticles" | translate }}</p>
      } @else {
        <p class="askPanel-section-label">{{ "AskSuggestions" | translate }}</p>
        @for (article of articles(); track article.path) {
          <a
            [href]="getArticleLink(article)"
            target="_blank"
            rel="noopener"
            class="askPanel-card d-flex align-items-center"
            [attr.aria-label]="('OpenArticle' | translate) + ': ' + article.title"
          >
            <div class="askPanel-card-text">
              <h5 class="askPanel-card-title">{{ article.title }}</h5>
              <span class="askPanel-card-description">{{ article.description }}</span>
            </div>
            <img class="askPanel-card-chevron" src="images/ask-panel/chevron.svg" width="14" height="14" alt="" />
          </a>
        }
      }
    </div>
  </ng-scrollbar>
  }

  @if (chatAvailable()) {
    <app-ask-panel-chat class="askPanel-body" [hidden]="activeTab() !== 'chat'" [panelOpened]="opened()" />
  }

  <!-- Technical support: opens Zoho's own floating Business Messaging chat (it can't be embedded here);
       the panel closes as the widget appears. -->
  @if (supportAvailable) {
    <ng-scrollbar class="askPanel-body" [hidden]="activeTab() !== 'support'">
      <div class="askPanel-body-inner">
        @if (!supportConfigured) {
          <p class="mat-body-1 f-s-14 askPanel-message">{{ "SupportUnavailable" | translate }}</p>
        } @else {
          <p class="askPanel-section-label">{{ "SupportIntro" | translate }}</p>
          @if (supportUnavailable()) {
            <p class="mat-body-1 f-s-14 askPanel-message askPanel-support-intro">{{ "SupportUnavailable" | translate }}</p>
          }
          <button
            type="button"
            class="askPanel-card askPanel-option d-flex align-items-start"
            [disabled]="supportOpening()"
            (click)="openSupport()"
          >
            <span class="askPanel-option-icon"><i-tabler name="headset" class="icon-20 d-flex"></i-tabler></span>
            <span class="askPanel-card-text">
              <h5 class="askPanel-card-title">{{ "SupportOptChat" | translate }}</h5>
              <span class="askPanel-card-description">{{ "SupportOptChatDesc" | translate }}</span>
            </span>
          </button>
        }
      </div>
    </ng-scrollbar>
  }
</div>
